export const HOME_DETAILS_REQUEST = 'HOME_DETAILS_REQUEST';
export const HOME_DETAILS_SUCCESS = 'HOME_DETAILS_SUCCESS';
export const HOME_DETAILS_FAIL = 'HOME_DETAILS_FAIL';